module.exports = __webpack_public_path__ + "a43d9bb0781ab95dd3420fdb05e0b04f.svg";